import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import type { Plan } from 'Components/widgets/payment-info/payment-form/PaymentPlan';
import type { PlanIframeProps, PaymentFormValues } from 'Src/types/payment';
import { PAYMENT_PLAN_IFRAME } from './BuyNowPayLater.const';

export type { PlanIframeProps } from 'Src/types/payment';

type Props = {
  paymentPlans: ReadonlyArray<Plan>;
  price: number;
  onLoaded: (plan: { id: string; display: boolean }) => void;
  displayIframe: boolean;
};

export const BuyNowPayLater = ({ paymentPlans, price, displayIframe, ...props }: Props) => {
  const formik = useFormikContext<PaymentFormValues>();

  useEffect(() => {
    paymentPlans.map(({ value: id }) => {
      const planId = String(id);
      if (!PAYMENT_PLAN_IFRAME[planId]) {
        props.onLoaded({ id: planId, display: false });
      }
    });
  }, []);

  return paymentPlans.map(({ value: id }) => {
    const planId = String(id);
    const PlanIframe = PAYMENT_PLAN_IFRAME[planId];
    const onPaymentPlanLoaded = (display: boolean) => props.onLoaded({ id: planId, display });
    return (
      PlanIframe && (
        <PlanIframe
          key={planId}
          onLoaded={onPaymentPlanLoaded}
          price={price}
          display={displayIframe && formik.values.paymentProviderId === planId}
        />
      )
    );
  });
};
